import './index.scss';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import Toast from '../../shared/Toast/Toast';
import { useTranslation } from 'react-i18next';
import { useFetchProfile } from '../../../store/Auth/authHooks';
import { useCloseOldModal } from '../../../store/modal/modalHooks';
import { Button, Form, ModalFooter, ModalHeader } from 'reactstrap';
import { useUpdateMedicalForm } from '../../../store/gym-management/GymHooks';
import MedicalFormSuccessMessage from '../../pages/gym-medical-form/MedicalFormSuccessMessage';
import UploadMedicalCertificateForm from '../../pages/gym-medical-form/UploadMedicalCertificateForm';

export interface UploadMedicalCertificateFormValues {
  file: string;
}

const UploadMedicalCertificate = () => {
  const { t } = useTranslation();
  const closeModal = useCloseOldModal();
  const fetchProfile = useFetchProfile();
  const updateMedicalForm = useUpdateMedicalForm();

  const [showSuccessPage, setShowSuccessPage] = useState(false);

  const defaultValues: UploadMedicalCertificateFormValues = {
    file: '',
  };

  const form = useForm({ defaultValues });
  const {
    handleSubmit,
    formState: {},
  } = form;

  const successMessageStatus = 'MEDICAL_FORM_APPROVAL_SUCCESS_MESSAGE_CONTENT';

  const onSubmit = (data: UploadMedicalCertificateFormValues) => {
    if (!data.file) {
      return Toast('error', t('MEDICAL_STATEMENT_NO_FILE_IN_UPLOAD'));
    }

    updateMedicalForm({
      medical_certificate: data.file,
    })
      .then(() => {
        onSuccess();
      })
      .catch((e) => {
        onFailure(e.message);
      });
  };

  const onSuccess = () => {
    fetchProfile().finally();
    setShowSuccessPage(true);
  };

  const onFailure = (errorMessage: string) => {
    const toastType = 'error';
    Toast(toastType, errorMessage, t);
  };

  const onCloseUploadModal = () => {
    closeModal();
  };

  return (
    <div className="upload-medical-certificate-modal">
      <div className="form-modal">
        <Form onSubmit={handleSubmit(onSubmit)}>
          {!showSuccessPage && (
            <ModalHeader>
              <p className="form-header-title">
                {t('UPLOAD_MEDICAL_CERTIFICATE_TEXT')}
              </p>
            </ModalHeader>
          )}
          {!showSuccessPage && (
            <>
              <UploadMedicalCertificateForm form={form} />
            </>
          )}
          {showSuccessPage && (
            <MedicalFormSuccessMessage successMessage={successMessageStatus} />
          )}
          {!showSuccessPage && (
            <ModalFooter className="medical-certificate-buttons">
              <Button
                type="button"
                color=""
                onClick={onCloseUploadModal}
                className="medical-certificate-buttons-cancel"
              >
                {t('CLOSE_BUTTON')}
              </Button>{' '}
              <Button type="submit" color="primary">
                {t('MEDICAL_CERTIFICATE_UPLOAD_TEXT_BUTTON')}
              </Button>{' '}
            </ModalFooter>
          )}
        </Form>
      </div>
    </div>
  );
};

export default UploadMedicalCertificate;
